var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.8002C19.3947 28.8002 22.6505 27.4516 25.0509 25.0512C27.4514 22.6507 28.7999 19.395 28.7999 16.0002C28.7999 12.6054 27.4514 9.34969 25.0509 6.94923C22.6505 4.54876 19.3947 3.2002 16 3.2002C12.6052 3.2002 9.34945 4.54876 6.94898 6.94923C4.54852 9.34969 3.19995 12.6054 3.19995 16.0002C3.19995 19.395 4.54852 22.6507 6.94898 25.0512C9.34945 27.4516 12.6052 28.8002 16 28.8002V28.8002ZM17.6 9.60019C17.6 9.17585 17.4314 8.76888 17.1313 8.46882C16.8313 8.16877 16.4243 8.0002 16 8.0002C15.5756 8.0002 15.1686 8.16877 14.8686 8.46882C14.5685 8.76888 14.4 9.17585 14.4 9.60019V16.0002C14.4 16.4245 14.5687 16.8314 14.8688 17.1314L19.3936 21.6578C19.5422 21.8065 19.7187 21.9244 19.9129 22.0048C20.1071 22.0853 20.3153 22.1267 20.5255 22.1267C20.7358 22.1267 20.944 22.0853 21.1382 22.0048C21.3324 21.9244 21.5089 21.8065 21.6576 21.6578C21.8062 21.5091 21.9241 21.3327 22.0046 21.1384C22.085 20.9442 22.1264 20.736 22.1264 20.5258C22.1264 20.3156 22.085 20.1074 22.0046 19.9132C21.9241 19.7189 21.8062 19.5425 21.6576 19.3938L17.6 15.3378V9.60019Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.76f45df3ef190e4ff90ee878791e673b.svg";
export { ForwardRef as ReactComponent };